/* @flow */

import Edit from './Edit';
import View from './View';

export const getEditComponent = () => Edit;
export const getViewComponent = () => View;
export const getRenderComponent = () => View;



// WEBPACK FOOTER //
// ./src/modules/edito/plugins/contact/index.js